/* eslint-disable */
import React, {useContext, useState} from "react";
import {TextSectionsDispatch, TextSectionsListContext} from "../context/TextSectionsListContext";
import ToolbarCustomSelect from "./ToolbarCustomSelect";
import {ConfigContext, ConfigDispatch} from "../context/ConfigContext";
import left from '../images/left.svg'
import center from '../images/center.svg'
import right from '../images/right.svg'
import {validateAllLetters} from "../services/helpers";
import {ModalDispatch} from "../context/ModalContext";
import {useLanguage} from "../context/LanguageContext";
import {PriceCalculationContext} from "../context/PriceCalculationContext";
import {COLORS_WITH_TYPE, MOUNTING_OPTIONS, isMountingSelectable, resolveMounting} from "../services/erpMapping";

export const ToolbarActions = ({
                                   index,
                                   onDeactivateItem,
                                   onSetFontSize,
                                   fontSize,
                                   onsetLetterSpacing,
                                   letterSpacing
                               }) => {

    const {t} = useLanguage();
    const {recalculateAllPrices} = useContext(PriceCalculationContext);
    const configData = useContext(ConfigContext);
    const configDataDispatch = useContext(ConfigDispatch);
    const textSectionDispatch = useContext(TextSectionsDispatch);
    const textSections = useContext(TextSectionsListContext);
    const modalDispatch = useContext(ModalDispatch);
    const [activateFontSelector, setActivateFontSelector] = useState(false);
    const [activateLetterSpacingSelector, setActivateLetterSpacingSelector] = useState(false);
    const [activateFontSizeSelector, setActivateFontSizeSelector] = useState(false);
    const [activateColorSelector, setActivateColorSelector] = useState(false);
    const [activateTypeSelector, setActivateTypeSelector] = useState(false);
    const [activateGridSelector, setActivateGridSelector] = useState(false);
    const [activateSnapSelector, setActivateSnapSelector] = useState(false);
    const [activateMountingSelector, setActivateMountingSelector] = useState(false);

    const translateConfigValue = (category, value) => {
        const key = `configData.${category}.${value}`;
        const translated = t(key);
        return translated === key ? value : translated;
    };

    // Mocowanie (bolec / taśma 3M) — tryb produktu, wybór użytkownika i blokada
    // taśmy dla rozmiarów 2 cm / 2,5 cm (jak na karcie produktu w sklepie).
    const mounting = resolveMounting(configData, textSections);
    const showMountingSelector = isMountingSelectable(configData.mountingType);
    const mountingOptions = MOUNTING_OPTIONS
        .filter((option) => !(mounting.restricted && option.key === 'tasma'))
        .map((option) => ({value: option.key, label: translateConfigValue('mounting', option.label)}));
    const mountingLabel = MOUNTING_OPTIONS.find((option) => option.key === mounting.key)?.label || '';

    const fontFamilyOptions = configData.fontsData.map((font) => {
        return {
            value: font.fontFamily,
            label: translateConfigValue('fonts', font.fontFamily)
        }
    });
    const selectFont = (e) => {
        const userConfirmed = confirm(
            t('toolbar.confirmFontChange')
        );

        if (!userConfirmed) {
            return;
        }
        configDataDispatch({
            'type': 'changeFontFamily',
            'payload': e.target.dataset.value
        })
        textSectionDispatch({
            'type': 'set',
            payload: []
        })
        setActivateFontSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSizeSelector(false);
    }
    /**
     * Zmiana rozmiaru czcionki w konfiguracji i sekcji tekstu
     * @param e
     * @returns {Promise<void>}
     */
    const selectFontSize = async (e) => {
        //Deaktywujemy wszystkie slelect
        setActivateFontSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSizeSelector(false);
        //pobieramy wartości
        const value = e.target.dataset.value;
        const oldValue = configData.selectedFontSize;
        await changeFontSizeInConfig(value);
        //Znajdujemy obiekt czcionki w konfiguracji
        const fontSizeObject = configData.fontsData.find(font => font.fontFamily === configData.selectedFont).fonts_conf.find(font => font.font_size.name === value);
        const fontSizeObjectFontSize = fontSizeObject.font_size;
        // Aktualizujemy konfigurację
        let updatedConfig = configData;
        updatedConfig.allowedSpecial = fontSizeObject.allowed_special;
        updatedConfig.allowedBigLetters = fontSizeObject.allowed_big_letters;
        updatedConfig.allowedSmallLetters = fontSizeObject.allowed_small_letters;
        updatedConfig.allowedNumbers = fontSizeObject.allowed_numbers;

        if(textSections.length !== 0) {
            //Pobieramy tekst i sprawdzamy czy dla tego tekstu zmiana czcionki jest dozwolona
            const rawContent = textSections[index].rawContent;
            const checkIfChangeIsAllowed = validateAllLetters(rawContent, updatedConfig);
            //Błąd, wyrzucamy komunikat i przywracamy stary rozmiar czcionki
            if (!checkIfChangeIsAllowed) {
                const allowedChars = [
                    updatedConfig.allowedSmallLetters ? t('toolbar.smallLetters') : '',
                    updatedConfig.allowedBigLetters ? t('toolbar.bigLetters') : '',
                    updatedConfig.allowedNumbers ? t('toolbar.numbers') : '',
                    updatedConfig.allowedSpecial ? t('toolbar.specialChars') : ''
                ].filter(Boolean).join(' ');
                const errorMessage = `
                ${t('toolbar.cannotChangeFontSize', {value})} <br/>
                ${t('toolbar.allowedCharsForSize')} <br/><strong>${allowedChars}</strong><br/>
            `;
                await showErrorMessage(errorMessage, t('toolbar.fontSizeChangeError'));
                //Przywracamy do starego rozmiaru czcionki
                await changeFontSizeInConfig(oldValue);
                return;
            }
        }
        // Aktualizujemy rozmiar czcionki w sekcji tekstu
        await changeFontSizeInTextSection(fontSizeObjectFontSize);
    }
    /**
     * Zmiana rozmiaru czcionki w sekcji tekstu
     * @param fontSizeObject
     * @returns {Promise<void>}
     */
    const changeFontSizeInTextSection = async (fontSizeObject) => {
        await textSectionDispatch({
            type: 'updateTextSectionFontSize',
            payload: {
                index,
                fontSizeValue: fontSizeObject.slug,
                fontSizeName: fontSizeObject.name,
                fontSizeErpId: fontSizeObject.id_erp,
            }
        });
        recalculateAllPrices();
    }
    /**
     * Zmiana rozmiaru czcionki - zmiana w konfiguracji
     * @param e
     * @returns {Promise<void>}
     */
    const changeFontSizeInConfig = async (value) => {
        await configDataDispatch({
            type: "changeFontSize",
            payload: value
        });
    }
    const selectType = (e) => {
        configDataDispatch({
            type: 'changeType',
            payload: e.target.dataset.value
        });
        // Wykończenie zmienia wiersz cennika — przeliczamy całą konfigurację.
        recalculateAllPrices();
        setActivateTypeSelector(false);
        setActivateFontSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSizeSelector(false);
    };
    const selectLetterSpacing = (e) => {
        //console.log('handleClick', e.target.dataset.value);
        //onsetLetterSpacing(e.target.dataset.value);
        setActivateFontSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSizeSelector(false);
        configDataDispatch({
            type: "changeLetterSpacing",
            payload: e.target.dataset.value
        });
        textSectionDispatch({
            type: 'updateTextSectionLetterSpacing',
            payload: {
                index,
                letterSpacing: e.target.dataset.value
            }
        });
        recalculateAllPrices();
    }
    const selectColor = (e) => {
        configDataDispatch({
            type: 'changeColor',
            payload: e.target.dataset.value
        });
        // Kolor zmienia wiersz cennika — przeliczamy całą konfigurację.
        recalculateAllPrices();
        setActivateColorSelector(false);
    };
    const selectMounting = (e) => {
        configDataDispatch({
            type: 'changeMounting',
            payload: e.target.dataset.value
        });
        // Mocowanie zmienia wiersz cennika — przeliczamy całą konfigurację.
        recalculateAllPrices();
        setActivateMountingSelector(false);
    };
    const toggleMountingList = () => {
        setActivateMountingSelector(!activateMountingSelector);
        setActivateTypeSelector(false);
        setActivateFontSizeSelector(false);
        setActivateColorSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSelector(false);
        setActivateGridSelector(false);
        setActivateSnapSelector(false);
    };
    const toggleFontsSizeList = () => {
        setActivateFontSizeSelector(!activateFontSizeSelector);
        setActivateColorSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSelector(false);
        setActivateGridSelector(false);
        setActivateSnapSelector(false);
    }
    const toggleLetterSpacingList = () => {
        setActivateLetterSpacingSelector(!activateLetterSpacingSelector);
        setActivateFontSizeSelector(false);
        setActivateColorSelector(false);
        setActivateFontSelector(false);
        setActivateGridSelector(false);
        setActivateSnapSelector(false);
    }
    const toggleFontsList = () => {
        setActivateFontSelector(!activateFontSelector);
        setActivateFontSizeSelector(false);
        setActivateColorSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateGridSelector(false);
        setActivateSnapSelector(false);
    }
    const toggleColorList = () => {
        setActivateColorSelector(!activateColorSelector);
        setActivateFontSizeSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSelector(false);
        setActivateGridSelector(false);
        setActivateSnapSelector(false);
    };
    const toggleTypeList = () => {
        setActivateTypeSelector(!activateTypeSelector);
        setActivateFontSizeSelector(false);
        setActivateColorSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSelector(false);
        setActivateGridSelector(false);
        setActivateSnapSelector(false);
    };

    const toggleTypeGrid = () => {
        setActivateGridSelector(!activateGridSelector);
        setActivateTypeSelector(false);
        setActivateFontSizeSelector(false);
        setActivateColorSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSelector(false);
        setActivateSnapSelector(false);
    };

    const toggleSnapSelector = () => {
        setActivateSnapSelector(!activateSnapSelector);
        setActivateGridSelector(false);
        setActivateTypeSelector(false);
        setActivateFontSizeSelector(false);
        setActivateColorSelector(false);
        setActivateLetterSpacingSelector(false);
        setActivateFontSelector(false);
    };

    function updateTextAlign(align) {
        textSectionDispatch({
            type: 'updateTextSectionTextAlign',
            payload: {
                index,
                textAlign: align
            }
        });
    }

    const showErrorMessage = (content, title = t('common.error'), timeout = 5000) => {
        return new Promise((resolve) => {
            //modalDispatch({type: "hideModal"});
            modalDispatch({
                type: "setModalContent",
                payload: {
                    title: title,
                    content: content,
                }
            });
            modalDispatch({type: "showModal"});
            //Czekamy 5 sekund i zamykamy modal
            setTimeout(() => {
                modalDispatch({type: "hideModal"});
            }, timeout);
            resolve();
        });
    }

    // Opcje dla widoku siatki
    const gridViewOptions = [
        { value: true, label: t('common.yes') },
        { value: false, label: t('common.no') }
    ];

    // Obsługa zmiany widoku siatki
    const handleGridViewChange = (e) => {
        const value = e.target.dataset.value === "true";
        configDataDispatch({
            type: 'toggleGridView',
            payload: value
        });
        setActivateGridSelector(false);
    };

    // Opcje dla przyciągania do siatki
    const snapToGridOptions = [
        { value: true, label: t('common.yes') },
        { value: false, label: t('common.no') }
    ];

    // Obsługa zmiany przyciągania do siatki
    const handleSnapToGridChange = (e) => {
        const value = e.target.dataset.value === "true";
        configDataDispatch({
            type: 'toggleSnapToGrid',
            payload: value
        });
        setActivateSnapSelector(false);
    };

    return (
        <div className="editor_top__actions" role="toolbar" aria-label={t('toolbar.editorActions')}>
            <ToolbarCustomSelect
                title={t('toolbar.selectFont')}
                value={configData.selectedFont}
                displayValue={translateConfigValue('fonts', configData.selectedFont)}
                options={fontFamilyOptions}
                active={activateFontSelector}
                toggleList={toggleFontsList}
                handleClick={selectFont}
                onClose={() => setActivateFontSelector(false)}
                loadFonts={true}
                // disabled={true}
            />
            <div className="text-align--center custom-select">
                <div className="custom-select__label" id="text-align-label">{t('toolbar.alignment')}</div>
                <div role="group" aria-labelledby="text-align-label" style={{display: 'flex', gap: '10px'}}>
                    <button
                        type="button"
                        style={{cursor: 'pointer', background: 'none', border: 'none', padding: 0}}
                        onClick={() => updateTextAlign('left')}
                        aria-label={t('toolbar.alignLeft')}
                    >
                        <img src={left} alt={t('toolbar.alignLeftAlt')}/>
                    </button>
                    <button
                        type="button"
                        style={{cursor: 'pointer', background: 'none', border: 'none', padding: 0}}
                        onClick={() => updateTextAlign('center')}
                        aria-label={t('toolbar.alignCenter')}
                    >
                        <img src={center} alt={t('toolbar.alignCenterAlt')}/>
                    </button>
                    <button
                        type="button"
                        style={{cursor: 'pointer', background: 'none', border: 'none', padding: 0}}
                        onClick={() => updateTextAlign('right')}
                        aria-label={t('toolbar.alignRight')}
                    >
                        <img src={right} alt={t('toolbar.alignRightAlt')}/>
                    </button>
                </div>
                <div></div>
            </div>
            <ToolbarCustomSelect
                title={t('toolbar.letterSpacing')}
                value={configData.selectedLetterSpacing}
                options={configData.fontsLetterSpacingOptions}
                active={activateLetterSpacingSelector}
                toggleList={toggleLetterSpacingList}
                handleClick={selectLetterSpacing}
                onClose={() => setActivateLetterSpacingSelector(false)}
            />
            <ToolbarCustomSelect
                title={t('toolbar.fontHeight')}
                value={configData.selectedFontSize}
                options={configData.fontSizeOptions}
                active={activateFontSizeSelector}
                toggleList={toggleFontsSizeList}
                handleClick={selectFontSize}
                onClose={() => setActivateFontSizeSelector(false)}
            />

            <ToolbarCustomSelect
                title={t('toolbar.color')}
                value={configData.selectedColor}
                displayValue={translateConfigValue('colors', configData.selectedColor)}
                options={configData.colorOptions.map((opt) => ({
                    value: opt.value,
                    label: translateConfigValue('colors', opt.value)
                }))}
                active={activateColorSelector}
                toggleList={toggleColorList}
                handleClick={selectColor}
                onClose={() => setActivateColorSelector(false)}
            />

            {
                // Wykończenie (mat / poler) tylko dla kolorów z COLORS_WITH_TYPE (srebrny) — jak w sklepie
                COLORS_WITH_TYPE.includes(parseInt(configData.selectedColorObject?.id, 10)) ?
                    <ToolbarCustomSelect
                        title={t('toolbar.type')}
                        value={configData.selectedType}
                        displayValue={translateConfigValue('types', configData.selectedType)}
                        options={configData.typeOptions.map((opt) => ({
                            value: opt.value,
                            label: translateConfigValue('types', opt.value)
                        }))}
                        active={activateTypeSelector}
                        toggleList={toggleTypeList}
                        handleClick={selectType}
                        onClose={() => setActivateTypeSelector(false)}
                    />
                    : null
            }
            {
                // Mocowanie (bolec / taśma 3M) — tylko gdy produkt na to pozwala (ACF mounting_type)
                showMountingSelector ?
                    <ToolbarCustomSelect
                        title={t('toolbar.mounting')}
                        value={mounting.key}
                        displayValue={translateConfigValue('mounting', mountingLabel)}
                        options={mountingOptions}
                        active={activateMountingSelector}
                        toggleList={toggleMountingList}
                        handleClick={selectMounting}
                        onClose={() => setActivateMountingSelector(false)}
                    />
                    : null
            }
            {/* Nowy select: Widok siatki */}
            <ToolbarCustomSelect
                title={t('toolbar.gridView')}
                value={configData.showGrid ? t('common.yes') : t('common.no')}
                options={gridViewOptions}
                active={activateGridSelector}
                toggleList={toggleTypeGrid}
                handleClick={handleGridViewChange}
                onClose={() => setActivateGridSelector(false)}
            />
            {/* Nowy select: Przyciągaj do siatki */}
            <ToolbarCustomSelect
                title={t('toolbar.snapToGrid')}
                value={configData.snapToGrid ? t('common.yes') : t('common.no')}
                options={snapToGridOptions}
                active={activateSnapSelector}
                toggleList={toggleSnapSelector}
                handleClick={handleSnapToGridChange}
                onClose={() => setActivateSnapSelector(false)}
            />
        </div>
    )
}
